import {getDeviceType} from "../webpack/modules/devices";

let enableReports = sessionStorage && !isBotOrCrawler() ? sessionStorage.getItem('core_web_vitals_reports_enabled') === 'true' : false;

if (enableReports) {
    let script = document.createElement('script');
    script.src = 'https://unpkg.com/web-vitals@5/dist/web-vitals.iife.js';
    document.head.appendChild(script);

    script.onload = function () {
        webVitals.onINP(function (metric) {
            if (metric.rating === 'poor' || metric.rating === 'needs-improvement') sendReport(metric);
        }, {reportAllChanges: true});
    };
}


function sendReport(metric)
{
    let events = [];

    metric.entries.forEach(function(event) {
        events.push(
            {
                duration: event.duration,
                startTime: event.startTime,
                processingStart: event.processingStart,
                processingEnd: event.processingEnd,
                inputDelay: event.processingStart - event.startTime,
                eventName: event.name,
                element: event.target ? event.target.cloneNode(false).outerHTML : null,
                parent: event.target.parentElement ? event.target.parentElement.cloneNode(false).outerHTML : null,
                child: event.target.children.length ? event.target.children[0].cloneNode(false).outerHTML : null,
                text: event.target ? event.target.innerText.trim() : null,
            }
        );
    });

    let data = {
        id: metric.id,
        name: metric.name,
        value: metric.value,
        delta: metric.delta,
        rating: metric.rating,
        url: window.location.href,
        device: getDeviceType(),
        connection: navigator.connection ? navigator.connection.effectiveType : 'unknown',
        events: events
    }

    navigator.sendBeacon('/ajax/website/core-web-vitals/send-report', JSON.stringify(data));
}

function isBotOrCrawler() {
    const userAgent = navigator.userAgent.toLowerCase();

    const botPatterns = [
        // Rastreadores principales de motores de búsqueda
        "googlebot",      // Google
        "bingbot",        // Microsoft Bing (Reemplaza "bing" y "msn")
        "baidu",          // Baidu
        "yandex",         // Yandex
        "slurp",          // Yahoo! Slurp
        "teoma",          // Antiguo motor de búsqueda, todavía usado
        "mediapartners",  // Google AdSense/Media Partnerships

        // Bots de IA y Modelos de Lenguaje
        "gpt",            // OpenAI GPT (Puede aparecer en algunos User Agents)
        "perplexity",     // Perplexity
        "openai",         // OpenAI
        "ia_bot",         // Un término genérico para bots de IA

        // Bots sociales y de análisis
        "facebot",        // Facebook
        "twitterbot",     // Twitter / X
        "linkedinbot",    // LinkedIn
        "pinterest",      // Pinterest
        "whatsapp",       // WhatsApp

        // Herramientas SEO, CDN, y genéricos
        "transparentcdn", // CDN/Prerender/Cache
        "screaming frog", // Herramienta SEO común
        "patrol",         // Patrones de seguridad o monitoreo
        "crawl",          // Palabra genérica "crawl"
        "spider",          // Palabra genérica "spider"
        "bot",            // Palabra genérica "bot"
    ];

    for (const pattern of botPatterns) {
        if (userAgent.includes(pattern)) {
            return true; // Es un bot/crawler conocido
        }
    }

    return false;
}
